import React from "react";
import { useSelector } from "react-redux";
import { UserNearbyTagInfo } from "../../redux/alerts";
import { presenceStatuses, Resident } from "../../redux/residents";
import { IAppState } from "../../redux/types";
import { AppStateUserProfile } from "../../redux/userProfile/";
import { StatusType, UsersProfile } from "../../redux/users";
import { useAvatar } from "../../utils/hooks/useAvatar";
const AvatarCurrentUser = React.memo(
  ({
    onClick,
    size = "98",
    includeEditIcon = false,
  }: {
    onClick?: () => void;
    size?: string;
    includeEditIcon?: boolean;
  }): JSX.Element => {
    const { picture, email, firstName, lastName, id } = useSelector<
      IAppState,
      AppStateUserProfile
    >((state) => state.userProfile);
    const { backgroundImage, text, color } = useAvatar({
      picture,
      email,
      firstName,
      lastName,
      id,
    });
    if (backgroundImage)
      return (
        <div className={`avatar-${size}`} onClick={onClick}>
          <div
            className="inner"
            style={{ backgroundImage: `url( ${backgroundImage})` }}
          />
          {includeEditIcon && (
            <div className="edit-file-btn">
              <i className="icon-edit"></i>
            </div>
          )}
        </div>
      );

    return (
      <div className={`avatar-${size}`} onClick={onClick}>
        <div
          className="inner"
          style={{ backgroundColor: color, color: "white" }}
        >
          <span>{text.toUpperCase()}</span>
        </div>
        {includeEditIcon && (
          <div className="edit-file-btn">
            <i className="icon-edit"></i>
          </div>
        )}
      </div>
    );
  }
);
AvatarCurrentUser.displayName = "AvatarCurrentUser";

const AvatarResidentUser = React.memo(
  ({
    profile,
    loadedFileStr,
    size = "100",
    clickable = true,
    useResidentIcon = false,
    stickyOnLoaded = false,
    callbackOnClick = undefined,
    children,
    view,
  }: {
    profile: UsersProfile | Resident | UserNearbyTagInfo;
    loadedFileStr?: string;
    size?: string;
    clickable?: boolean;
    useResidentIcon?: boolean;
    stickyOnLoaded?: boolean;
    callbackOnClick?: (isOpen: boolean) => void;
    children?: any;
    view?: string;
  }): JSX.Element => {
    const email = profile ? profile["email"] || "" : "";
    const id = profile ? profile["id"] || "" : "";
    const picture = profile ? profile["picture"] || "" : "";
    const { backgroundImage, text, color } = useAvatar({
      picture: loadedFileStr ? loadedFileStr : stickyOnLoaded ? "" : picture,
      email,
      firstName: profile?.firstName,
      lastName: profile?.lastName,
      id: id,
    });
    const isDischarged = profile
      ? "nodePresence" in profile
        ? (profile as Resident)?.nodePresence === presenceStatuses.discharged
        : (profile as UsersProfile)?.status === StatusType.SUSPENDED
      : false;
    console.log(view);
    if (backgroundImage)
      return (
        <div
          className={`avatar-${size} ${view === "card" ? "md-10" : ""}`}
          style={{
            marginRight: view !== "tile" ? "8px" : "",
          }}
        >
          <div
            className={`inner ${isDischarged ? "grey-scale" : ""}`}
            style={{
              backgroundImage: `url( ${backgroundImage})`,
            }}
          ></div>
          {children}
        </div>
      );

    return (
      <div
        className={`avatar-${size} ${view === "card" ? "md-10" : ""}`}
        style={{
          marginRight: view !== "tile" ? "8px" : "",
        }}
      >
        <div
          className={`inner ${isDischarged ? "grey-scale" : ""} flex-center`}
          style={{ backgroundColor: color, color: "white" }}
        >
          <div className="text-span">{text.toUpperCase()}</div>
        </div>

        {children}
      </div>
    );
  }
);
AvatarResidentUser.displayName = "AvatarResidentUser";
const UnknowUser = React.memo(
  ({
    children,
    className = "small heebo-m",
    size = 32,
    showName = false,
  }: {
    children?: any;
    className?: string;
    size?: number;
    showName?: boolean;
  }): JSX.Element => {
    return (
      <div className="user-data">
        <div className={`${size} no-print-element center }`}>
          <i className="icon-TypeDefault" style={{ fontSize: size + "px" }}>
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
            <span className="path4"></span>
            <span className="path5"></span>
          </i>
        </div>
      </div>
    );
  }
);
UnknowUser.displayName = "UnknowUser";
export { AvatarCurrentUser, AvatarResidentUser, UnknowUser };
